module.exports = __webpack_public_path__ + "static/media/home-sidebar-selected.c549d9d5.svg";